export default __webpack_public_path__ + "static/6-cc5c6a9a721d7fbe1d717c522f93e6c2.jpg";